import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vac',
  templateUrl: './vac.component.html',
  styleUrls: ['./vac.component.scss']
})
export class VacComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
